export type DomainIds = {
  dealerId: string;
  applicationId?: string;
  borrowerId?: string;
};

export function requireDealerId(dealerId?: string): string {
  if (!dealerId) throw new Error("dealerId is required");
  return dealerId;
}

export function lazyDealerId(ids: DomainIds) {
  return () => requireDealerId(ids.dealerId);
}

export function requireApplicationId(applicationId?: string): string {
  if (!applicationId) throw new Error("applicationId is required");
  return applicationId;
}

export function requireBorrowerId(borrowerId?: string): string {
  if (!borrowerId) throw new Error("borrowerId is required");
  return borrowerId;
}
